import { render, staticRenderFns } from "./GeneralHistory.vue?vue&type=template&id=3b568d52&scoped=true"
import script from "./GeneralHistory.vue?vue&type=script&lang=js"
export * from "./GeneralHistory.vue?vue&type=script&lang=js"
import style0 from "./GeneralHistory.vue?vue&type=style&index=0&id=3b568d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b568d52",
  null
  
)

export default component.exports